import { CitationDto } from './citationDto';

export interface CitationPagedResultDto {
    totalCount?: number;
    items?: Array<CitationDto> | null;
}
